import { Theme } from '@mui/material'

const useStyles = {
  formInputContainer: (theme: Theme) => ({
    width: '100%',
    marginBottom: theme.spacing(2),
  }),
  stickyBanner: (theme: Theme) => ({
    position: 'sticky',
    top: '69px',
    zIndex: theme.zIndex.appBar,
  }),
  outerContainer: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginTop: '32px',
    paddingBottom: '220px', // Reserve space for the fixed signature + button footer
  },
  agreementContainer: {
    gap: 2,
    marginBottom: '24px',
    maxWidth: '600px',
    marginX: 'auto',
  },
  errorContainer: {
    minHeight: '600px',
    maxWidth: '600px',
    marginX: 'auto',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 4,
  },
  errorButtonRow: {
    gap: 2,
    marginTop: 1,
  },
  footerContainer: (theme: Theme) => ({
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    paddingY: '16px',
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
    zIndex: theme.zIndex.appBar,
  }),
  footerContent: (theme: Theme) => ({
    width: '100%',
    maxWidth: theme.breakpoints.values.sm,
    flexDirection: 'column',
    paddingX: '16px',
  }),
  signatureButtonRow: {
    width: '100%',
    justifyContent: 'space-between',
  },
}

export default useStyles
